/**
 * JSR
 * komentare.js
 * JQuery funkce pro komentáře
 *
 * @package komentare
 *
 * @author Jiří Chalupný <jchalupny@skit.cz>
 * @copyright (c) 2007-2026 Josef Šmíd
 * @version 2.5.9
 */

$(document).ready(function() 
{   
  // komentař (delegovaně, aby fungovalo i pro donačtené dotazy)
  $(document).on('click', '.comm_odpoved', function(e)
  {
    $('body').css('overflow', 'hidden');
    $(document).scrollTop();
    
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();
    $(".dialog_pridat_kom").dialog({
      resizable: true,
      width: ( windowWidth <= 600 ? windowWidth - 50 : "80%" ),
      height: ( windowHeight <= 920 ? windowHeight - 80 : "auto" ),
      modal: true,
      closeText: "",
      dialogClass: 'respozive_dialog',
      beforeClose: function () {
        $('body').css('overflow', '');
      },
      buttons: {
        "Zavřít": function () {
          $('body').css('overflow', '');
          $(this).dialog("close");
        }
      }
    });
    e.preventDefault();
    e.stopPropagation();
  });
  $('.dialog_kom_napsat').click(function ()
  {

    $('body').css('overflow', 'hidden');
    $(document).scrollTop();
    $('#komOdp').html("");
    $('input[name="komOdp"]').val('');
    $('input[name="idNadrazeneho"]').val('');
    
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();
    $(".dialog_pridat_kom").dialog({
      resizable: true, 
      width: ( windowWidth <= 600 ? windowWidth - 50 : "80%" ),
      height: ( windowHeight <= 920 ? windowHeight - 80 : "auto" ),
      modal: true,
      closeText: "",
      dialogClass: 'respozive_dialog',
      beforeClose: function () {
        $('body').css('overflow', '');
      },
      buttons: {
        "Zavřít": function () {
          $('body').css('overflow', '');
          $(this).dialog("close");
        }
      }
    });
  });

  
  $(document).on('keyup', function(e) {
    if (e.key === 27 ) $(".dialog_pridat_kom").dialog("close");
  });
  //rozbalení odpovědí (delegovaně, aby fungovalo i pro donačtené dotazy)
  $(document).on('click', '.komentar', function () {
    if($(this).parent('div').children('.comm_celek_chidren').length > 0)
    {
      if (!$(this).parent('div').children('.comm_celek_chidren').hasClass('open_komentar_children'))
      {
          $(this).parent('div').children('.comm_celek_chidren').slideDown("slow", function () {

          });
          $(this).parent('div').children('.comm_celek_chidren').addClass('open_komentar_children');
          $(this).addClass('open_komentar');

      } else
      {
          $(this).parent('div').children('.comm_celek_chidren').slideUp("slow", function () {
            $(this).parent('div').children('.comm_celek_chidren').removeClass('open_komentar_children');
            $(this).parent('div').find('.open_komentar').removeClass('open_komentar');
            $(this).removeClass('open_komentar');

            $(this).parent('div').find('.open_komentar_children').css('display','none');
            $(this).parent('div').find('.open_komentar_children').removeClass('open_komentar_children');
          });
   
      }
    }
  });
  $('input[name="email"]').change(function() {
    checkemail($(this));
  });
  $('textarea[name="komentar_text"]').change(function() {
      if($(this).val() !== '')
      {
        $(this).removeAttr('style');
        return true;
      }
      else
      {
        $(this).css('border-color','red');
        return false;
      }
  });
  $('input[name="jmeno"]').change(function() {
      if($(this).val() !== '')
      {
        $(this).removeAttr('style');
        return true;
      }
      else
      {
        $(this).css('border-color','red');
        return false;
      }
  });
});
function checkemail(element)
{
   if(element.val().match(/^[-!#$%&\'*+\\./0-9=?A-Z^_`a-z{|}~]+@[-!#$%&\'*+\\/0-9=?A-Z^_`a-z{|}~]+\.[-!#$%&\'*+\\./0-9=?A-Z^_`a-z{|}~]+$/))
  {
    element.parent().parent().find('.chyba_req_email').hide();
    element.removeAttr('style');
    return true;
  }
  else
  {
    element.parent().parent().find('.chyba_req_email').show();
    element.css('border-color','red');
    return false;
  }
}